import { render, staticRenderFns } from "./processInspectionRead.vue?vue&type=template&id=d23ef1c8"
import script from "./processInspectionRead.vue?vue&type=script&lang=js"
export * from "./processInspectionRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports